"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXCLUDED_FORM_FIELDS = exports.UNAVAILABLE_REASONS = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var UNAVAILABLE_REASONS = (0, _keyMirror.default)({
  ALL_DAY_EVENT: null,
  EVENT: null,
  BUFFER: null,
  MINIMUM_NOTICE: null,
  PAST: null,
  DATE_NOT_CONFIGURED: null,
  TIME_NOT_CONFIGURED: null
});
/* In Meetings' certain customer properties are always being set in
 * ContactHelper.createOrUpdateContact. Thus, we shouldn't pass those
 * properties as booking data in formFields.
 * https://git.hubteam.com/HubSpot/Meetings/blob/master/MeetingsService/src/main/java/com/hubspot/meetings/service/book/ContactsHelper.java/#L86
 */

exports.UNAVAILABLE_REASONS = UNAVAILABLE_REASONS;
var EXCLUDED_FORM_FIELDS = ['firstname', 'lastname', 'lifecyclestage'];
exports.EXCLUDED_FORM_FIELDS = EXCLUDED_FORM_FIELDS;